import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';

import ChevronToggle from '@src/components/common/ChevronToggle';

class HeaderMenuMobileItem extends React.PureComponent {
    static propTypes = {
        itemId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        isActive: PropTypes.bool,
        displayName: PropTypes.string,
        children: PropTypes.node,
        onClick: PropTypes.func.isRequired,
    };

    handleOnClick = () => {
        const { itemId, onClick } = this.props;

        onClick(itemId);
    };

    handleOnKeyDown = (e) => {
        const { itemId, onClick } = this.props;

        if (e.key === 'Enter' || e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            onClick(itemId);
        }
    };

    renderTitle = () => {
        const { itemId, isActive, displayName } = this.props;
        const classNames = classnames({
            active: isActive,
        });

        return (
            <Accordion.Toggle
                as={Card.Header}
                eventKey={itemId}
                className={classNames}
                tabIndex={0}
                onClick={this.handleOnClick}
                onKeyDown={this.handleOnKeyDown}
            >
                { displayName }
                <ChevronToggle isActive={isActive} />
            </Accordion.Toggle>
        );
    };

    renderBody = () => {
        const { itemId, children } = this.props;

        if (!children) {
            return null;
        }

        return (
            <Accordion.Collapse eventKey={itemId}>
                <Card.Body>
                    { children }
                </Card.Body>
            </Accordion.Collapse>
        );
    };

    render() {
        return (
            <Card className="border-left-0 border-right-0 rounded-0">
                { this.renderTitle() }
                { this.renderBody() }
            </Card>
        );
    }
}

export default HeaderMenuMobileItem;
